// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__Z1vYj","gradient":"Footer_gradient__pLJpp"};